export default __webpack_public_path__ + "static/media/step2 dark.2c26d8d3.svg";